var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-facebook w-100 mb-2",on:{"click":_vm.fbLogin}},[_c('i',{staticClass:"fa fa-facebook",attrs:{"aria-hidden":"true"}}),_vm._v("    以 Facebook 帳號登入 ")])}
var staticRenderFns = []

export { render, staticRenderFns }